var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColXsOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 13,
    viewBox: "0 0 3 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51174 0.464938H1.25892C0.563637 0.464938 0 0.916439 0 1.47339V11.5266C0 12.0836 0.563637 12.5351 1.25892 12.5351H1.51174C2.20703 12.5351 2.77066 12.0836 2.77066 11.5266V1.47339C2.77066 0.916439 2.20703 0.464938 1.51174 0.464938Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColXsOwner);
export default __webpack_public_path__ + "static/media/col_xs_owner.b8e9e534f7857d531a8a8566d2def66a.svg";
export { ForwardRef as ReactComponent };